export default [
	{
		settings: true,
		text: "ID",
		value: "employee_id",
		func: true,
		valueFilter: 'filter_id',
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Personal name",
		value: "name",
		func: true,
		valueFilter: 'filter_name',
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Company",
		value: "company",
		func: true,
		valueFilter: 'filter_company',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Department",
		value: "department",
		func: true,
		valueFilter: 'filter_department',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Office",
		value: "office",
		func: true,
		valueFilter: 'filter_office',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Email",
		value: "email",
		func: true,
		valueFilter: 'filter_email',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Phone",
		value: "phone",
		func: true,
		valueFilter: 'filter_phone',
		model: { value: 'list' },
		sortable: true,
		toLeft: true,
	},
	{
		settings: true,
		text: "Phone 2",
		value: "phone2",
		func: true,
		valueFilter: 'filter_phone2',
		model: { value: 'list' },
		sortable: true,
		toLeft: true,
	},
	{
		settings: true,
		text: "Status",
		value: "active",
		valueFilter: 'filter_active',
		model: { value: 'list' },
		func: true,
		sortable: true,
		align: 'center',
		isStatus: true,
	},
	{
		settings: true,
		buttons: [
			{
				perm: { or: [ 10, 9 ] },
				value: 'edit',
				text: 'Edit employee',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: {
					or: [ 11 ]
				},
				value: 'delete',
				text: 'Delete employee',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		]
	},
];

